<div class="form-check">
    <ng-content></ng-content>
    <label class="form-check-radio" [for]="idFor">
        {{ label }}
    </label>
</div>
